module.exports = __webpack_public_path__ + "static/media/logo-cdp.46cb79b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-cdp.svg
// module id = 357
// module chunks = 0